/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Row, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { PurchaseDocument } from 'src/core/models'
import React, { useState, useEffect } from 'react'
import { documentListColumns } from 'src/core/table-columns'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import DocumentListHeader from './DocumentListHeader/DocumentListHeader'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { purchaseDocumentsSelector, setDocumentsIsAllCollapse } from 'src/features'
import { CustomSeo, CustomCol, GoBackLink, CustomCard, CustomTable, PageTitle } from 'src/components'
import PurchaseDocumentButtonsContent from './PurchaseDocumentButtonsContent/PurchaseDocumentButtonsContent'

const VidaliteDocumentsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [expandedRows, setExpandedRows] = useState([])
  const { filtered: documentList, loading, isAllCollapse } = useAppSelector(purchaseDocumentsSelector)
  const { width } = useWindowSize()
  const isMobile = width <= 800

  useEffect(() => {
    setExpandedRows(isAllCollapse ? documentList.map(d => d.id) : [])
  }, [isAllCollapse])

  return <>
    {/* Seo */}
    <CustomSeo title={t('My ClimateTrade: Validate Documents')} />

    {/* Page Header */}
    <Row>
      <CustomCol>
        <GoBackLink link={'/admin'} label={t('Validate.GoBack')} />
      </CustomCol>
      <CustomCol>
        <div className={isMobile ? 'centered-div' : 'float-right'}>
          <PageTitle>{t('Document.Title')}</PageTitle>
        </div>
      </CustomCol>
    </Row>

    {/* Document List */}
    <CustomCard loading={loading}>
      <DocumentListHeader quantity={documentList.length} />
      <Divider />
      <CustomTable
        pageSize={10}
        dataSource={documentList}
        columns={documentListColumns}
        rowClassName={'fade-animation pointer'}
        rowKey={(document: PurchaseDocument) => document.id}
        expandable={{
          expandRowByClick: true,
          expandedRowKeys: expandedRows,
          expandedRowRender: (document: PurchaseDocument) => {
            return <PurchaseDocumentButtonsContent document={document} />
          }
        }}
        expandIcon={({ expanded, onExpand, record }) => expanded ? <>
          <Tooltip title={t('Document.Close')} color={'blue'}>
            <DownOutlined
              className='fade-animation'
              onClick={e => {
                const newRows = expandedRows.filter(id => id !== record.id)
                setExpandedRows(newRows)
                dispatch(setDocumentsIsAllCollapse(false))
                onExpand(record, e)
              }}
            />
          </Tooltip>
        </> : (
          <Tooltip title={t('Document.Check')} color={'blue'}>
            <RightOutlined
              className='fade-animation'
              onClick={e => {
                dispatch(setDocumentsIsAllCollapse(false))
                setExpandedRows([...expandedRows, record.id])
                onExpand(record, e)
              }}
            />
          </Tooltip>
        )}
      />
    </CustomCard>
  </>
}

export default VidaliteDocumentsPageContent
